import { Box, IconButton } from '@mui/material';
import { ArrowsInSimple, ArrowsOutSimple } from '@phosphor-icons/react';

interface CollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export const CollapseButton = ({
  isCollapsed,
  onToggle,
}: CollapseButtonProps) => {
  return (
    <Box
      className="nodrag"
      sx={{
        position: 'absolute',
        top: '6px',
        right: '34px',
        zIndex: 10,
      }}
    >
      <IconButton
        onClick={onToggle}
        size="small"
        sx={{
          padding: '4px',
          color: '#667085',
          '&:hover': {
            backgroundColor: '#F2F4F7',
          },
        }}
      >
        {isCollapsed ? (
          <ArrowsOutSimple size={20} />
        ) : (
          <ArrowsInSimple size={20} />
        )}
      </IconButton>
    </Box>
  );
};

